<div class="component-content" [class.padding-0-24]="!admin">
  @if (!admin) {
    <div class="page-navigation">
      <div class="circle-large" (click)="onBack()">
        <div class="circle-icon">
          <i class="fa-regular fa-arrow-left fa-xl"></i>
        </div>
      </div>
    </div>
  }
  <div class="header">
    <div class="font-medium-display-medium">Vollständige Vita</div>
    @if (userService.userIsAdmin(userService.currentUser$.value)) {
      <button class="inwi-text-button-medium-outline" (click)="onEdit()">
        <div class="button-content">
          <div class="button-icon">
            <i class="fa-regular fa-pen"></i>
          </div>
          <div class="button-text">Bearbeiten</div>
        </div>
      </button>
    }
  </div>
  <div class="main-content">
    @if (isLoading) {
      <div class="user-header">
        <p-skeleton width="100px" height="100px" borderRadius="50%" />
        <div class="flex-c gap-4">
          <p-skeleton width="200px" height="28px" borderRadius="16px" />
          <p-skeleton width="180px" height="20px" borderRadius="16px" />
        </div>
      </div>
    } @else {
      <div class="user-header">
        <div class="avatar">
          <app-avatar [user]="user" />
        </div>
        <div class="flex-c gap-4">
          <div class="section-title">
            {{ user?.firstname + ' ' + user?.lastname }}
          </div>
          <div>{{ user.jobTitle }}</div>
        </div>
      </div>
    }
    <mat-divider></mat-divider>
    @if (isLoading) {
      <div class="flex-c gap-20">
        <p-skeleton width="100%" height="100px" borderRadius="16px" />
        <p-skeleton width="100%" height="100px" borderRadius="16px" />
        <p-skeleton width="100%" height="100px" borderRadius="16px" />
      </div>
    } @else {
      <div class="flex-c gap-20">
        <div class="flex-c gap-16">
          <div class="section-title">Allgemeine Informationen:</div>
          <ul>
            @if (user?.description1) {
              <li class="font-regular-body-large">
                {{ user.description1 }}
              </li>
            }
            @if (user?.description2) {
              <li class="font-regular-body-large">
                {{ user.description2 }}
              </li>
            }
            @if (user?.description3) {
              <li class="font-regular-body-large">
                {{ user.description3 }}
              </li>
            }
          </ul>
        </div>
        @if (user?.trainings && user.trainings.length > 0) {
          <div class="flex-c gap-16">
            <div class="section-title">Wichtige Fortbildungen:</div>
            <ul>
              @for (training of user.trainings; track training) {
                <li class="font-regular-body-large">
                  {{ training }}
                </li>
              }
            </ul>
          </div>
        }
        <div class="flex-c gap-16">
          @if (user?.careerSteps && user.careerSteps.length > 0) {
            <div class="flex-c gap-16">
              <div class="section-title">Beruflicher Werdegang:</div>
              <ul>
                @for (careerStep of user.careerSteps; track careerStep) {
                  <li class="font-regular-body-large">
                    {{ careerStep }}
                  </li>
                }
              </ul>
            </div>
          }
        </div>
        <div class="flex-c gap-16">
          @if (
            (user?.publications && user.publications.length > 0) ||
            (user?.engagements && user.engagements.length > 0) ||
            (user?.contributions && user.contributions.length > 0)
          ) {
            <div class="flex-c gap-16">
              <div class="section-title">
                Publikationen, Engagement und Beiträge:
              </div>
              <ul>
                @for (publication of user.publications; track publication) {
                  <li class="font-regular-body-large">
                    @if (publication.link) {
                      <a [href]="publication.link" target="_blank">{{
                        publication.title
                      }}</a>
                    } @else {
                      {{ publication.title }}
                    }
                  </li>
                }
                @for (engagement of user.engagements; track engagement) {
                  <li class="font-regular-body-large">
                    {{ engagement }}
                  </li>
                }
                @for (contribution of user.contributions; track contribution) {
                  <li class="font-regular-body-large">
                    {{ contribution }}
                  </li>
                }
              </ul>
            </div>
          }
        </div>
        <div class="flex-c gap-16"></div>
      </div>
    }
  </div>
</div>
